import { render, staticRenderFns } from "./OfmReference.vue?vue&type=template&id=15ad815a&"
import script from "./OfmReference.vue?vue&type=script&lang=js&"
export * from "./OfmReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports